import script from "./CertificateReview.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateReview.vue?vue&type=script&setup=true&lang=js"

import "./CertificateReview.vue?vue&type=style&index=0&id=1e8ab8e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e8ab8e2"]])

export default __exports__